// extracted by mini-css-extract-plugin
export default {"form":"answer-form_form__NwwW7","input":"answer-form_input__hO7vN","button":"answer-form_button__q8jhI","shake":"answer-form_shake__tCM4u"};